import { Button, Flex, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldTextarea from '@/components/shared/form/FieldTextarea';
import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';

import s from './FeedbackContent.module.scss';

const FeedbackContent: React.FC = () => {
  const {
    answerRatingStore: { fieldText, putNegativeRate, meta, feedbackMeta, feedbackAnswerId },
  } = useOrganizationChatAiPageStore();

  const handleClick = React.useCallback(async () => {
    await putNegativeRate(feedbackAnswerId ?? undefined);
  }, [feedbackAnswerId, putNegativeRate]);

  return (
    <Flex className={s.root} gap="md" direction="column">
      <Text size="sm">Напишите, что случилось</Text>
      <FieldTextarea store={fieldText} />
      <Button
        loading={meta.isLoading || feedbackMeta.isLoading}
        onClick={handleClick}
        disabled={!feedbackAnswerId || !fieldText.value?.trim()}
        className={s.root__footer}
      >
        Отправить
      </Button>
    </Flex>
  );
};

export default observer(FeedbackContent);
